export default __webpack_public_path__ + "static/media/General.3306f6cc.jpg";